import { httpClient } from 'services/index'

export const getDevices = (params: any): Promise<any> => httpClient.get('/devices', { params }).then(_ => _.data)

export const getDevice = (id: any): Promise<any> => httpClient.get(`/devices/${id}`).then(_ => _.data)

export const addDevice = (data: any): Promise<any> => httpClient.post('/devices', data).then(_ => _.data)
